import styled from '@emotion/styled'

export const VersionWrapper = styled.div`
  position: fixed;
  bottom: 0.5rem;
  right: 0.5rem;
  font-size: 10px;
  color: rgb(255 255 255 / 50%);
  pointer-events: none;
`

export const Version = () => {
  return (
    <VersionWrapper>
      {__APP_VERSION__}+{__APP_COMMIT__}
    </VersionWrapper>
  )
}
